/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaginatedOrganizationBareLogsResponseDto,
} from '../models/index';
import {
    PaginatedOrganizationBareLogsResponseDtoFromJSON,
    PaginatedOrganizationBareLogsResponseDtoToJSON,
} from '../models/index';

export interface OrganizationBareLogsExportControllerExportOrganizationLogsRequest {
    to: string;
    from: string;
    organizationId: string;
}

export interface OrganizationBareLogsExportControllerPreviewOrganizationLogsRequest {
    to: string;
    from: string;
    organizationId: string;
    limit?: number;
    page?: number;
}

/**
 * 
 */
export class OrganizationLogsExportApi extends runtime.BaseAPI {

    /**
     * Download organization bare logs as a zip of JSON files grouped by asset serial number (SUPER_ADMIN only)
     */
    async organizationBareLogsExportControllerExportOrganizationLogsRaw(requestParameters: OrganizationBareLogsExportControllerExportOrganizationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['to'] == null) {
            throw new runtime.RequiredError(
                'to',
                'Required parameter "to" was null or undefined when calling organizationBareLogsExportControllerExportOrganizationLogs().'
            );
        }

        if (requestParameters['from'] == null) {
            throw new runtime.RequiredError(
                'from',
                'Required parameter "from" was null or undefined when calling organizationBareLogsExportControllerExportOrganizationLogs().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationBareLogsExportControllerExportOrganizationLogs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['to'] != null) {
            queryParameters['to'] = requestParameters['to'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/logs/export`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Download organization bare logs as a zip of JSON files grouped by asset serial number (SUPER_ADMIN only)
     */
    async organizationBareLogsExportControllerExportOrganizationLogs(requestParameters: OrganizationBareLogsExportControllerExportOrganizationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.organizationBareLogsExportControllerExportOrganizationLogsRaw(requestParameters, initOverrides);
    }

    /**
     * Preview organization bare logs paginated (SUPER_ADMIN only)
     */
    async organizationBareLogsExportControllerPreviewOrganizationLogsRaw(requestParameters: OrganizationBareLogsExportControllerPreviewOrganizationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedOrganizationBareLogsResponseDto>> {
        if (requestParameters['to'] == null) {
            throw new runtime.RequiredError(
                'to',
                'Required parameter "to" was null or undefined when calling organizationBareLogsExportControllerPreviewOrganizationLogs().'
            );
        }

        if (requestParameters['from'] == null) {
            throw new runtime.RequiredError(
                'from',
                'Required parameter "from" was null or undefined when calling organizationBareLogsExportControllerPreviewOrganizationLogs().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationBareLogsExportControllerPreviewOrganizationLogs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = requestParameters['to'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['from'] = requestParameters['from'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/logs/bare`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedOrganizationBareLogsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Preview organization bare logs paginated (SUPER_ADMIN only)
     */
    async organizationBareLogsExportControllerPreviewOrganizationLogs(requestParameters: OrganizationBareLogsExportControllerPreviewOrganizationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedOrganizationBareLogsResponseDto> {
        const response = await this.organizationBareLogsExportControllerPreviewOrganizationLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
